import * as Yup from "yup";

export function initialValues(user, formData = {}) {
  const userData = { ...formData, ...user };
  //funcion para inicializar los valores de los campos

  return {
    name: userData?.name || "",
    email: user?.email || "",
    code: userData?.code && userData.code.length >= 6 ? userData.code : "",
    phone: userData?.phone || "",
    mobile: userData?.mobile || "",
    type: userData?.type || "supplier",
    isPerson: userData?.isPerson || false,
    socialNetworks: {
      website: userData?.socialNetworks?.website || "",
    },
    miniature: userData?.miniature || "",
    file: null,
  };
}
export function validationSchema(t) {
  return Yup.object({
    // Valida los campos principales del formulario
    email: Yup.string()
      .email(t("partners:validation.emailInvalid"))
      .required(t("partners:validation.emailRequired")),
    name: Yup.string().required(t("partners:validation.nameRequired")),
    code: Yup.string().required(t("partners:validation.codeRequired")),
    mobile: Yup.string().required(t("partners:validation.mobileRequired")),
  });
}
